export const data = {
  section: {
    title: 'Trade'
  },
  error: {
    title: 'Trade',
    subtitle: 'Não foi possível carregar o seu patrimônio neste momento',
    description: 'Aguarde alguns minutos e tente novamente.',
    buttonLabel: 'Tentar novamente'
  }
};
